import styled from "styled-components";
import { Tabs } from "antd";
import { theme } from "../../styles/theme";

export const AntTabs = styled(Tabs)`
  &&& {
    .ant-tabs {
      &-tab {
        color: ${({ theme }) => theme.colors.white};
        font-family: ${({ theme }) => theme.fonts.family};
        font-size: ${(props) => props.size || theme.fonts.size.sm};

        &-active .ant-tabs-tab-btn {
          color: ${({ theme }) => theme.colors.red};
        }

        &-btn {
          display: flex;
          align-items: center;
          gap: 4px;
        }

        &-disabled,
        &-disabled:hover {
          color: ${({ theme }) => theme.colors.white};
        }
      }

      &-ink-bar {
        background-color: ${({ theme }) => theme.colors.red};
      }
    }

    &.ant-tabs-top > .ant-tabs-nav::before {
      display: none !important;
    }

    &.ant-tabs {
      &-default {
        i {
          font-size: 21px;
        }
      }
      &-small {
        i {
          font-size: 18px;
        }
      }
      &-large {
        i {
          font-size: 24px;
        }
      }
    }
  }
`;
